module.exports = __webpack_public_path__ + "img/12.580718d0.jpg";